module.exports = __webpack_public_path__ + "static/img/2.32ae100.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/2.png
// module id = YmwX
// module chunks = 0